(function () {
  function updateInstallationFields(container, variant) {
    if (!variant) return;

    var skuField = container.querySelector('[data-ilmas-installation-sku]');
    var variantField = container.querySelector('[data-ilmas-installation-variant]');
    var urlField = container.querySelector('[data-ilmas-installation-url]');
    var productUrl = container.getAttribute('data-product-url') || window.location.href;

    if (skuField) skuField.value = variant.sku || '';
    if (variantField) variantField.value = variant.title || '';

    if (urlField) {
      try {
        var selectedUrl = new URL(productUrl, window.location.origin);
        selectedUrl.searchParams.set('variant', variant.id);
        urlField.value = selectedUrl.toString();
      } catch (error) {
        urlField.value = productUrl;
      }
    }
  }

  function initialiseInstallationQuotes(root) {
    var scope = root || document;
    var quotes = scope.querySelectorAll('[data-ilmas-poolstar-installation]:not([data-ilmas-initialised])');

    quotes.forEach(function (quote) {
      quote.setAttribute('data-ilmas-initialised', 'true');

      var statusMessage = quote.querySelector('.ilmas-installation-quote__success, .ilmas-installation-quote__status .errors');
      if (statusMessage) {
        quote.open = true;
        if (!statusMessage.hasAttribute('tabindex')) statusMessage.setAttribute('tabindex', '-1');
        statusMessage.focus();
      }

      var productDetails = quote.closest('[data-product-details]');
      var variantSelection = productDetails ? productDetails.querySelector('[data-variant-selection]') : null;
      if (!variantSelection) return;

      if (typeof variantSelection.getVariant === 'function') {
        variantSelection.getVariant().then(function (variant) {
          updateInstallationFields(quote, variant);
        });
      }

      variantSelection.addEventListener('variant-change', function (event) {
        updateInstallationFields(quote, event.detail && event.detail.variant);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseInstallationQuotes(document);
    });
  } else {
    initialiseInstallationQuotes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseInstallationQuotes(event.target);
  });
}());
